<template>
    <div v-if="visible">
        <button @click="onClick">Button ({{ buttonLabel() }})</button>
    </div>
</template>

<script>
export default {
    props : {
        parent : {
            type: Object,
            // required: true
        },
        id : {
            type: String,
            // required: true
        }
    },
    computed : {
    },
    data() {
        return {
            visible: false,
        }
    },
    methods: {
        buttonLabel() {
            // console.log(this.parent.$attrs);
            return this.parent.$attrs["data-component-name"];
        },
        onClick() {
            // console.log("button", this.id);
            this.$emit("update", this.id);
        },
        show() {
            this.visible = true;
        },
        hide() {
            this.visible = false;
        },
        value() {
            console.log("Dynamic Component's Value", this.id);
            return this.id;
        }
    }
}
</script>
